export default function xmlEncode(value: string) {
	if (!value) return;
	value = value.replace(/&/g, "&amp;");
	value = value.replace(/</g, "&lt;");
	value = value.replace(/>/g, "&gt;");
	value = value.replace(/"/g, "&quot;");
	return value;
}
